import React from "react";
import { VariantProps } from ".";
import LoginLink from "./LoginLink";

const W = ({ selectedProduct }: VariantProps) => (
  <div className="map map-override mapW">
    {selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers ? (
      <p className="price enter-email">
        {" Contact us or "}
        <LoginLink>login</LoginLink>
        <br />
        {" for pricing "}
      </p>
    ) : (
      <p className="price enter-email">Contact us for pricing</p>
    )}
    <p className="to-see-price noborder">Call 717-392-7472</p>
  </div>
);

export default W;
